import TemplateView from '../../../../TemplateView'
import {connect} from '../../../../redux/utils'
import {getCurrentUsedUser, getLicenses} from '../../selectors'
import LicenseCardsContainer from './LicensesCardsContainer'
import {licensesType, UNLIMITED_USERS_COUNT} from '../../constants'
import {cancelAddUsers, startAddUsers} from './addUsers/actions'
import {bindActionCreators} from 'redux'
import {getCurrentLicenseId} from './addUsers/selectors'
import {CURRENT_PRODUCT} from '../../../../constants'
import {isShowLicenseCountDownTip} from '../../../../components/licenseCountDownTip/selectors'

class LicensesList extends TemplateView {
    constructor({
        startAddUsers = () => {},
        cancelAddUsers = () => {},
        onPurchaseClick = () => {},
    }) {
        super()

        this.state = {
            licenses: [],
            currentUsersCount: 0,
            licenseId: 0,
            licenseExpires: false,
        }

        this.callbacks = {
            onPurchaseClick,
        }

        this.actions = {
            startAddUsers,
            cancelAddUsers,
        }

        this.licenseContainers = {}

        this.onAnyStatePropertyChanged(['licenses', 'currentUsersCount', 'licenseExpires'], () => {
            this.updateList()
        })

        this.onStatePropertyChanged('licenseId', (licenseId, prevLicenseId) => {
            this.licenseContainers[prevLicenseId] && this.licenseContainers[prevLicenseId].setState({
                showAddUsersCard: false
            })

            this.licenseContainers[licenseId] && this.licenseContainers[licenseId].setState({
                showAddUsersCard: true
            })
        })
    }

    templateHtml() {
        return '<div class="list"\>'
    }

    afterRender() {
        this.updateList()
    }

    updateList() {
        this.getEl().empty()
        this.licenseContainers = {}

        this.state.licenses.forEach(license => {
            this.licenseContainers[license.id] = new LicenseCardsContainer(
                {
                    licenseId: license.id,
                    active: license.active,
                    trial: license.type === licensesType.TRIAL,
                    startDate: new Date(license.startDate),
                    expirationDate: new Date(license.endDate),
                    daysToExpiration: license.daysToExpiration,
                    issueDate: new Date(license.issueDate),
                    gracePeriod: license.gracePeriod,
                    endDateWithGracePeriod: new Date(license.endDateWithGracePeriod),
                    unlimited: license.usersCount === UNLIMITED_USERS_COUNT,
                    allowedUsersCount: license.usersCount,
                    free: license.type === licensesType.FREE,
                    expired: license.expired,
                    formattedName: this._getFormattedName(license),
                    currentUsersCount: this.state.currentUsersCount,
                    licensesMonthCount: license.durationInMonths,
                    product: CURRENT_PRODUCT,
                    licenseExpires: this.state.licenseExpires,
                    onCancelButtonClick: () => {
                        this.actions.cancelAddUsers()
                    },
                    onAddUsersButtonClick: () => {
                        this.actions.startAddUsers(license)
                    },
                    onPurchaseClick: this.callbacks.onPurchaseClick,
                }
            ).init(this.getEl())
        })
    }

    _getFormattedName(license) {
        return license.firstName + ' ' + license.lastName
    }
}

export default connect(
    (state) => ({
        licenses: getLicenses(state),
        currentUsersCount: getCurrentUsedUser(state),
        licenseId: getCurrentLicenseId(state),
        licenseExpires: isShowLicenseCountDownTip(state),
    }),
    (dispatch) => ({
        startAddUsers: bindActionCreators(startAddUsers, dispatch),
        cancelAddUsers: bindActionCreators(cancelAddUsers, dispatch),
    })
)(LicensesList)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/licenseList/LicenseList.js